import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Syne:wght@700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
.pp-root{min-height:100vh;background:linear-gradient(145deg,#06112b,#112359,#1a3570);font-family:'DM Sans',sans-serif;color:#e2e8f0;}
.pp-root::before{content:'';position:fixed;inset:0;z-index:0;background-image:linear-gradient(rgba(28,115,186,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(28,115,186,0.04) 1px,transparent 1px);background-size:52px 52px;pointer-events:none;}
.pp-body{position:relative;z-index:1;max-width:680px;margin:0 auto;padding:20px 16px 60px;}
.pp-back{display:inline-flex;align-items:center;gap:6px;color:#5aaef7;font-size:13px;text-decoration:none;font-weight:600;margin-bottom:20px;}
/* Hero card */
.pp-hero{background:linear-gradient(135deg,rgba(28,115,186,.2),rgba(90,174,247,.1));border:1px solid rgba(28,115,186,.25);border-radius:20px;padding:24px;margin-bottom:20px;display:flex;gap:20px;align-items:center;flex-wrap:wrap;}
.pp-passport-icon{font-size:56px;}
.pp-stats-row{display:flex;flex-wrap:wrap;gap:12px;flex:1;}
.pp-stat{text-align:center;min-width:70px;}
.pp-stat-num{font-family:'Syne',sans-serif;font-size:26px;font-weight:800;color:#5aaef7;}
.pp-stat-label{font-size:10px;color:#64748b;text-transform:uppercase;letter-spacing:1px;margin-top:2px;}
/* Tabs */
.pp-tabs{display:flex;gap:2px;border-bottom:1px solid rgba(255,255,255,.07);margin-bottom:18px;overflow-x:auto;}
.pp-tab{padding:9px 16px;border:none;background:transparent;color:#64748b;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;cursor:pointer;border-bottom:2px solid transparent;white-space:nowrap;transition:all .18s;}
.pp-tab.active{color:#5aaef7;border-bottom-color:#5aaef7;}
/* Badges */
.pp-badges-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(100px,1fr));gap:10px;}
.pp-badge-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:14px;padding:16px 10px;text-align:center;transition:all .18s;}
.pp-badge-card.earned{border-color:rgba(245,166,35,.3);background:rgba(245,166,35,.06);}
.pp-badge-icon{font-size:32px;margin-bottom:6px;}
.pp-badge-name{font-size:11px;font-weight:600;color:#e2e8f0;}
.pp-badge-desc{font-size:10px;color:#64748b;margin-top:2px;}
/* Visits */
.pp-visit-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:12px;padding:13px;margin-bottom:8px;display:flex;gap:12px;align-items:center;}
.pp-visit-icon{width:42px;height:42px;border-radius:10px;background:rgba(28,115,186,.15);display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;}
.pp-visit-name{font-size:13px;font-weight:600;color:#e2e8f0;margin-bottom:2px;}
.pp-visit-meta{font-size:11px;color:#64748b;}
.pp-visit-method{font-size:9px;padding:2px 8px;border-radius:99px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;}
.pp-visit-nfc{background:rgba(28,115,186,.15);color:#5aaef7;border:1px solid rgba(28,115,186,.25);}
.pp-visit-gps{background:rgba(52,211,153,.1);color:#34d399;border:1px solid rgba(52,211,153,.2);}
/* Journal */
.pp-journal-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:14px;padding:16px;margin-bottom:10px;}
.pp-journal-title{font-size:15px;font-weight:700;color:#e2e8f0;margin-bottom:5px;}
.pp-journal-body{font-size:13px;color:#94a3b8;line-height:1.65;}
.pp-journal-date{font-size:10px;color:#475569;margin-top:8px;}
/* Countries */
.pp-countries{display:flex;flex-wrap:wrap;gap:7px;}
.pp-country-tag{padding:5px 13px;border-radius:99px;background:rgba(28,115,186,.1);border:1px solid rgba(28,115,186,.2);color:#5aaef7;font-size:12px;font-weight:600;}
/* Add journal */
.pp-add-journal{background:rgba(255,255,255,.04);border:1px dashed rgba(255,255,255,.15);border-radius:14px;padding:20px;text-align:center;cursor:pointer;transition:all .2s;margin-bottom:14px;}
.pp-add-journal:hover{background:rgba(255,255,255,.07);border-color:rgba(28,115,186,.4);}
/* Spinner */
.pp-spinner{width:32px;height:32px;border:3px solid rgba(28,115,186,.15);border-top-color:#1c73ba;border-radius:50%;animation:spin .7s linear infinite;margin:40px auto;}
@keyframes spin{to{transform:rotate(360deg)}}
/* Section */
.pp-sec{margin-bottom:20px;}
.pp-sec-title{font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#5aaef7;margin-bottom:14px;}
`;

const TYPE_ICON = { business:'🏢', heritage:'🏛️', nature:'🌿', event:'🎪', emergency:'🚑', tourism:'🗺️', education:'🎓', transport:'🚌', community:'🤝', public:'🏛️' };

export default function Passport() {
  const navigate = useNavigate();
  const [passport, setPassport]   = useState(null);
  const [badges,   setBadges]     = useState([]);
  const [tab,      setTab]        = useState('overview');
  const [loading,  setLoading]    = useState(true);
  const [journal,  setJournal]    = useState({ title:'', body:'' });
  const [addingJ,  setAddingJ]    = useState(false);
  const [showJForm, setShowJForm] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get('/passport'),
      api.get('/passport/badges/all'),
    ]).then(([p, b]) => {
      setPassport(p.data);
      setBadges(b.data);
    }).catch(() => navigate('/login'))
    .finally(() => setLoading(false));
  }, [navigate]);

  const addJournal = async () => {
    if (!journal.title.trim()) return;
    setAddingJ(true);
    try {
      await api.post('/passport/journal', journal);
      setPassport(p => ({ ...p, travelJournal: [...(p.travelJournal||[]), { ...journal, createdAt: new Date() }] }));
      setJournal({ title:'', body:'' });
      setShowJForm(false);
    } catch {} finally { setAddingJ(false); }
  };

  if (loading) return <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#06112b'}}><div style={{width:32,height:32,border:'3px solid rgba(28,115,186,.15)',borderTopColor:'#1c73ba',borderRadius:'50%',animation:'spin .7s linear infinite'}}><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div></div>;
  if (!passport) return null;

  const earnedBadgeIds = new Set((passport.badges||[]).map(b=>b.badgeId));

  return (
    <div className="pp-root">
      <style>{CSS}</style>
      <div className="pp-body">
        <Link to="/dashboard" className="pp-back">← Dashboard</Link>

        {/* Passport hero */}
        <div className="pp-hero">
          <div className="pp-passport-icon">🛂</div>
          <div className="pp-stats-row">
            <div className="pp-stat"><div className="pp-stat-num">{passport.totalVisits||0}</div><div className="pp-stat-label">Visits</div></div>
            <div className="pp-stat"><div className="pp-stat-num">{passport.uniquePlaces||0}</div><div className="pp-stat-label">Places</div></div>
            <div className="pp-stat"><div className="pp-stat-num">{(passport.countries||[]).length}</div><div className="pp-stat-label">Countries</div></div>
            <div className="pp-stat"><div className="pp-stat-num">{(passport.badges||[]).length}</div><div className="pp-stat-label">Badges</div></div>
          </div>
        </div>

        {/* Tabs */}
        <div className="pp-tabs">
          {[['overview','🌍 Overview'],['badges','🏅 Badges'],['visits','📍 Visits'],['journal','📔 Journal']].map(([id,label])=>(
            <button key={id} className={`pp-tab${tab===id?' active':''}`} onClick={()=>setTab(id)}>{label}</button>
          ))}
        </div>

        {/* OVERVIEW */}
        {tab==='overview' && (
          <div>
            {(passport.countries||[]).length > 0 && (
              <div className="pp-sec">
                <div className="pp-sec-title">Countries Visited</div>
                <div className="pp-countries">{passport.countries.map(c=><span key={c} className="pp-country-tag">🌍 {c}</span>)}</div>
              </div>
            )}
            {(passport.cities||[]).length > 0 && (
              <div className="pp-sec">
                <div className="pp-sec-title">Cities</div>
                <div className="pp-countries">{passport.cities.map(c=><span key={c} className="pp-country-tag">🏙️ {c}</span>)}</div>
              </div>
            )}
            <div className="pp-sec">
              <div className="pp-sec-title">Recent Visits</div>
              {(passport.visits||[]).slice(-5).reverse().map((v,i)=>(
                <div key={i} className="pp-visit-card">
                  <div className="pp-visit-icon">{TYPE_ICON[v.placeType]||'📍'}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div className="pp-visit-name">{v.placeName||'Unknown place'}</div>
                    <div className="pp-visit-meta">{new Date(v.visitedAt).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}</div>
                  </div>
                  <span className={`pp-visit-method ${v.method==='nfc'?'pp-visit-nfc':'pp-visit-gps'}`}>{v.method}</span>
                </div>
              ))}
              {!passport.visits?.length && <div style={{color:'#334155',fontSize:13,textAlign:'center',padding:20}}>No visits yet. Use the Explore map to check in!</div>}
            </div>
            <div style={{textAlign:'center',marginTop:16}}>
              <button onClick={()=>navigate('/explore')} style={{padding:'11px 24px',borderRadius:12,border:'none',background:'linear-gradient(135deg,#1c73ba,#2b8de0)',color:'#fff',font:'700 14px/1 DM Sans,sans-serif',cursor:'pointer'}}>
                🗺️ Explore the Map
              </button>
            </div>
          </div>
        )}

        {/* BADGES */}
        {tab==='badges' && (
          <div className="pp-badges-grid">
            {badges.map(b=>{
              const earned = earnedBadgeIds.has(b.id);
              return(
                <div key={b.id} className={`pp-badge-card${earned?' earned':''}`} style={{opacity:earned?1:.45}}>
                  <div className="pp-badge-icon">{b.icon||'🏅'}</div>
                  <div className="pp-badge-name">{b.name}</div>
                  {b.requirement&&<div className="pp-badge-desc">{b.requirement}</div>}
                  {earned&&<div style={{fontSize:9,color:'#f5a623',marginTop:4,fontWeight:700}}>EARNED</div>}
                </div>
              );
            })}
            {!badges.length && <div style={{gridColumn:'1/-1',color:'#334155',textAlign:'center',padding:30}}>No badges available yet</div>}
          </div>
        )}

        {/* VISITS */}
        {tab==='visits' && (
          <div>
            {(passport.visits||[]).length === 0
              ? <div style={{color:'#334155',textAlign:'center',padding:40}}>No visits yet</div>
              : [...(passport.visits||[])].reverse().map((v,i)=>(
                <div key={i} className="pp-visit-card">
                  <div className="pp-visit-icon">{TYPE_ICON[v.placeType]||'📍'}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div className="pp-visit-name">{v.placeName}</div>
                    <div className="pp-visit-meta">{new Date(v.visitedAt).toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'})}</div>
                    {v.badgesEarned?.length>0 && <div style={{fontSize:10,color:'#f5a623',marginTop:2}}>🏅 Earned: {v.badgesEarned.join(', ')}</div>}
                  </div>
                  <span className={`pp-visit-method ${v.method==='nfc'?'pp-visit-nfc':'pp-visit-gps'}`}>{v.method}</span>
                </div>
              ))
            }
          </div>
        )}

        {/* JOURNAL */}
        {tab==='journal' && (
          <div>
            {!showJForm ? (
              <div className="pp-add-journal" onClick={()=>setShowJForm(true)}>
                <div style={{fontSize:24,marginBottom:6}}>📝</div>
                <div style={{fontSize:13,color:'#5aaef7',fontWeight:600}}>Add journal entry</div>
                <div style={{fontSize:11,color:'#475569',marginTop:2}}>Document your travels</div>
              </div>
            ) : (
              <div style={{background:'rgba(255,255,255,.04)',border:'1px solid rgba(28,115,186,.2)',borderRadius:14,padding:16,marginBottom:14}}>
                <input value={journal.title} onChange={e=>setJournal(j=>({...j,title:e.target.value}))} placeholder="Entry title…"
                  style={{width:'100%',background:'rgba(255,255,255,.05)',border:'1px solid rgba(28,115,186,.2)',borderRadius:8,padding:'9px 12px',color:'#e2e8f0',fontFamily:'DM Sans,sans-serif',fontSize:14,outline:'none',marginBottom:10}}/>
                <textarea value={journal.body} onChange={e=>setJournal(j=>({...j,body:e.target.value}))} placeholder="Write about your experience…"
                  rows={4} style={{width:'100%',background:'rgba(255,255,255,.05)',border:'1px solid rgba(28,115,186,.2)',borderRadius:8,padding:'9px 12px',color:'#e2e8f0',fontFamily:'DM Sans,sans-serif',fontSize:13,outline:'none',resize:'vertical'}}/>
                <div style={{display:'flex',gap:8,marginTop:10}}>
                  <button onClick={()=>{setShowJForm(false);setJournal({title:'',body:''}); }} style={{flex:1,padding:9,borderRadius:8,border:'1px solid rgba(255,255,255,.1)',background:'rgba(255,255,255,.05)',color:'#64748b',cursor:'pointer',font:'600 13px DM Sans,sans-serif'}}>Cancel</button>
                  <button onClick={addJournal} disabled={addingJ||!journal.title.trim()} style={{flex:2,padding:9,borderRadius:8,border:'none',background:'linear-gradient(135deg,#1c73ba,#2b8de0)',color:'#fff',cursor:'pointer',font:'700 13px DM Sans,sans-serif',opacity:addingJ?.6:1}}>{addingJ?'Saving…':'Save Entry'}</button>
                </div>
              </div>
            )}
            {[...(passport.travelJournal||[])].reverse().map((e,i)=>(
              <div key={i} className="pp-journal-card">
                <div className="pp-journal-title">{e.title}</div>
                {e.body && <p className="pp-journal-body">{e.body}</p>}
                <div className="pp-journal-date">{new Date(e.createdAt).toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'})}</div>
              </div>
            ))}
            {!passport.travelJournal?.length && !showJForm && <div style={{color:'#334155',textAlign:'center',padding:30,fontSize:13}}>Your travel journal is empty</div>}
          </div>
        )}
      </div>
    </div>
  );
}